import { tabletSize, mobileSize } from "@src/utils/screensize-helper";
import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { ScrollView, View } from "react-native";
import CopyRightContent from "./copy-right";
import SignUpNow from "./signupnow";
import useStyles from "./styles.css";
import WelcomGuest from "./welcome-guest";
import WelcomGuestMobile from "./welcome-guest-mobile";

const DrawerComponentScreen = () => {
  const styles = useStyles();
  const isTablet = tabletSize();
  const isMobile = tabletSize();

  return (
    <View pointerEvents="box-none" style={[styles.v_drawer_container ]}>
      <LinearGradient
        colors={["#1C242C", "#1C242C", "#1C242C", "#1C242C"]}
        style={[styles.linear_style]}
      />
      <View style={[styles.linear_style]}>
        <ScrollView showsHorizontalScrollIndicator={false}>
          {(isTablet || isMobile) ? <WelcomGuestMobile /> : <WelcomGuest /> }
          <SignUpNow />
        </ScrollView>
       <CopyRightContent />
      </View>
    </View>
  );
};

export default React.memo(DrawerComponentScreen);
